import wrap from 'wraptile';
import {
    ApTimelineMetadata,
    ApTimeline,
} from '@accurate-player/accurate-player-components-external';
import {QCNoteData} from 'VideoAudioQC/QCTabs/QCReport/List/List';
import {AdBreakData} from 'VideoAudioQC/QCTabs/AdBreaks/Table/Table';
import {MarkupData} from 'VideoAudioQC/QCTabs/Markup/Table/Table';
import {SelectNextPreviousMarker} from '../Timeline/Redux/TimelineActions';

export interface ITimeline extends ApTimeline {
    onZoomChange: (min: number, max: number) => void;
}

export type GoToMarkerProps = {
    next: boolean,
    selectNextPreviousMarker: SelectNextPreviousMarker,
}

type TimelineMetadataOrNull = ApTimelineMetadata | null;

export const isMarkerVisible = (start: number, end: number, zoomMin: number, zoomMax: number) => {
    if (start >= zoomMin && start <= zoomMax && end >= zoomMin && end <= zoomMax)
        return true;
    
    return false;
};

export const onAdBreakNoteZoomIn = (marker: AdBreakData) => {
    const timeline: ITimeline | null = document.querySelector('ap-timeline-basic');
    const {start} = marker;
    
    if (!timeline || start === undefined)
        return null;
    
    const end = start + 1;
    
    adjustZoomInterval(timeline, start, end);
};

export const onQcNoteZoomIn = (marker: QCNoteData | MarkupData) => {
    const timeline: ITimeline | null = document.querySelector('ap-timeline-basic');
    const {start, end} = marker;
    
    if (!timeline || start === undefined || end === undefined)
        return null;
    
    adjustZoomInterval(timeline, start, end);
};

export const adjustZoomInterval = (timeline: ITimeline, start: number, end: number) => {
    const {
        zoomMin,
        zoomMax,
    } = timeline;
    
    if (isMarkerVisible(start, end, zoomMin, zoomMax))
        return null;
    
    if ((end - start) <= (zoomMax - zoomMin)) {
        // marker can fit inside current zoom interval -> pan zoom interval to marker location
        const zoomInterval = zoomMax - zoomMin;
        const intervalDiff = zoomInterval - (end - start);
        const newZoomMin = Math.round(Math.max(timeline.min, (start - intervalDiff / 2)));
        const newZoomMax = Math.round(Math.min(timeline.max, (newZoomMin + zoomInterval)));
        
        timeline.onZoomChange(newZoomMin, newZoomMax);
    } else {
        // marker is larger compared to current zoom interval so we need to zoom out to fit marker
        const startDiff = start - zoomMin;
        const endDiff = end - zoomMax;
        const newZoomMin = Math.round(Math.max(timeline.min, zoomMin + startDiff - 50));
        const newZoomMax = Math.round(Math.min(timeline.max, zoomMax + endDiff + 50));
        
        timeline.onZoomChange(newZoomMin, newZoomMax);
    }
};

export const getSelectedTimelineRow = (): TimelineMetadataOrNull => {
    const metadataRows = document.querySelectorAll('ap-timeline-metadata') as NodeListOf<ApTimelineMetadata>;
    
    let metadata: TimelineMetadataOrNull = null;
    
    for (const row of metadataRows) {
        if (row.selection && row.selection.length > 0) {
            metadata = row;
        }
    }
    
    return metadata;
};

export const onGoToNextPrevious = wrap((props: GoToMarkerProps) => {
    const {
        selectNextPreviousMarker,
        next,
    } = props;
    
    const metadata = getSelectedTimelineRow();
    
    if (!metadata)
        return;
    
    const markerApi = metadata.api.markerApi(metadata.selection[0]);
    const marker = next ? markerApi.nextMarker() : markerApi.previousMarker();
    
    if (marker) {
        selectNextPreviousMarker(marker.identifier);
    }
});
